<ng-container #dynamic></ng-container>


// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/building-block.component.ts.BuildingBlockComponent.html